var map = {
	"./de-hoge-dijk.png": 9697,
	"./delfland.png": 6731,
	"./duke.png": 7342,
	"./herkenbosche.png": 2554,
	"./prise-d`eau.png": 5319,
	"./regthuys.png": 9810,
	"./westwoud.png": 655,
	"./zaanse.png": 3222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6086;